import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { participantsList } from '../participant.model';
import { FormControl } from '@angular/forms';
import { debounceTime, map, take } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-participants',
  templateUrl: './participants.component.html',
  styleUrls: ['./participants.component.scss']
})
export class ParticipantsComponent implements OnInit {

  allParticipants: Array<any>;
  participantsToFilter: Array<any>;
  investors: Array<any>;
  corporates: Array<any>;
  startups: Array<any>;
  universities: Array<any>;
  students: Array<any>;
  finalists: Array<any>;

  pubOrganisations: Array<any>;
  researchers: Array<any>;
  press: Array<any>;

  searchQuery: FormControl = new FormControl();

  constructor(private afs: AngularFirestore) { }

  ngOnInit(): void {
    // if (participans) {
    //   this.allParticipants = JSON.parse(participans);
    //   this.divideParticipants(this.allParticipants);
    // } else {
      this.getParticipants().subscribe((data) => {
        this.allParticipants = data;
        this.divideParticipants(this.allParticipants);
      })
    // }
    // of(participantsList).subscribe((data: any) => {
    //    // console.log('subscription')
    //   this.allParticipants = data.map((p) => {
    //     delete p.firstname;
    //     delete p.lastname;
    //     return p;
    //   })
    //   this.divideParticipants(this.allParticipants);
    // });

    this.searchQuery.valueChanges.pipe(
      debounceTime(400)
    ).subscribe((q) => {
      this.search(q);
    })
  }

  divideParticipants = (participants: Array<any>) => {
    this.investors = participants.filter((p) => {
      return p.category == 'Investor';
    })
    this.corporates = participants.filter((p) => {
      return p.category == 'Corporate';
    })
    this.startups = participants.filter((p) => {
      return p.category == 'Start-up or scale-up';
    })
    this.universities = participants.filter((p) => {
      return p.category == 'University';
    })
    this.students = participants.filter((p) => {
      return p.category == 'Students and learners';
    })
    this.pubOrganisations = participants.filter((p) => {
      return p.category == 'Public organisation';
    })
    this.researchers = participants.filter((p) => {
      return p.category == 'Research center';
    })
    this.press = participants.filter((p) => {
      return p.category == 'Press and media';
    })
    
    this.finalists = participants.filter((p) => {
      return p.category == 'Finalist';
    })
  }

  search = (q) => {
    this.participantsToFilter = [...this.allParticipants];
    const toRet = this.participantsToFilter.filter((participant: any) => {
      const a = participant.displayName.toLowerCase();
      const result = a.includes(q.toLowerCase());
       // console.log(result);
      if (result) {
        return true;
      } else {
        return false;
      }
    });
    this.divideParticipants(toRet);
  }

  goToUrl(url) {
    window.open(url, '__blank');
  }

  getParticipants() {
    return this.afs.collection('users').valueChanges().pipe(
      map((actions: any) => {
        return actions.map((a) => {
          return {
            displayName: a.displayName,
            company: a.company,
            linkedin: a.linkedin,
            category: a.category
          }
        })
      }),
      take(1)
    )
  }

  validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
  }
}
